// test1376
(1376 && 0);
